import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Libraries
import Select from 'react-select';
// Formik
import { useFormikContext } from 'formik';
// Elements
import Label from '../elements/Label';
import Error from '../elements/Error';
var MultiSelectField = function MultiSelectField(_ref) {
  var _ref$formik = _ref.formik,
    formik = _ref$formik === void 0 ? {} : _ref$formik,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    fieldId = _ref.fieldId,
    data = _ref.data;
  var _useFormikContext = useFormikContext(),
    handleChange = _useFormikContext.handleChange,
    values = _useFormikContext.values;
  var choices = typeof data.choices === 'string' ? JSON.parse(data.choices) : data.choices;
  var options = choices.map(function (choice) {
    return {
      value: choice.value,
      label: choice.text
    };
  });
  var selected = options.filter(function (choice) {
    var isSelected = values[fieldId] ? values[fieldId].indexOf(choice.value) !== -1 : false;
    return isSelected;
  });
  // Conditional logic
  if (data.conditionalLogic) {
    // Whether or not to show the field
    if (data.conditionalLogic.actionType === 'SHOW') {
      var show = true;
      data.conditionalLogic.rules.forEach(function (rule) {
        if (rule.operator === 'IS') {
          if (values["input_".concat(rule.fieldId)] !== rule.value) {
            show = false;
          }
        }
        if (rule.operator === 'IS_NOT') {
          if (values["input_".concat(rule.fieldId)] === rule.value) {
            show = false;
          }
        }
      });
      if (!show) {
        return null;
      }
    }
  }
  return _jsxs("div", {
    className: "form-duuf-group form-duuf-group-".concat(data.type.toLowerCase()).concat(data.cssClass ? " ".concat(data.cssClass) : ''),
    children: [_jsx(Label, {
      fieldId: fieldId,
      data: data
    }), _jsx(Error, {
      fieldId: fieldId,
      data: data,
      hasError: hasError,
      formik: formik
    }), _jsx(Select, {
      onChange: function onChange(event) {
        var values = event ? event.map(function (edge) {
          return edge.value;
        }) : [];
        handleChange({
          target: {
            name: fieldId,
            value: values
          }
        });
      },
      placeholder: data.placeholder,
      options: options,
      value: selected,
      classNamePrefix: "form-duuf-multiselect",
      isMulti: true
    })]
  });
};
export default MultiSelectField;